var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabasesSkillSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84101 2.7851C8.90355 4.11476 7.68267 5.25543 7.03135 6.74417C6.79742 7.27885 6.71973 7.85911 6.47084 8.37604C6.21761 8.90196 5.91372 9.51814 5.72585 10.0647C5.35469 11.1444 4.4841 11.9876 3.88822 12.924C3.53769 13.4748 2.95841 14.3324 2.41953 14.7262C2.14511 14.9267 1.40939 15.89 1.73485 15.9714C2.4927 16.1608 3.13567 16.5639 3.81017 16.9611C4.73772 17.5073 5.66156 17.9195 6.48857 18.6178C7.53419 19.5008 8.77494 20.1297 9.79844 21.0444C10.6009 21.7614 11.2979 22.5923 12.1114 23.3041C12.8139 23.9188 13.6599 24.3719 14.3748 24.975C14.4275 25.0195 14.9364 25.447 14.875 25.5391C14.8116 25.6341 14.0529 24.6596 13.9917 24.56",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0606 1.69958C24.5659 5.25165 22.9316 8.74108 21.4488 12.2997C20.5291 14.507 19.7559 16.7383 18.9726 19.001C18.3569 20.7796 17.5942 22.5152 16.9292 24.2727C16.6983 24.883 16.5395 25.5062 16.4042 26.1422C16.1827 27.1833 16.2052 25.971 16.2268 25.5179",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.381 0.93335C30.6826 2.416 31.9287 3.90773 33.3117 5.31103C34.4419 6.45787 34.942 8.11509 35.5751 9.55391C36.232 11.047 36.8896 12.2834 37.8597 13.5768C37.9744 13.7299 38.3138 14.1087 38.3138 14.3076C38.3138 14.4032 37.8559 14.4006 37.7816 14.4105C37.5288 14.4442 37.2274 14.6585 37.0154 14.7901C33.1703 17.1767 30.5707 20.6262 28.3097 24.4465C27.9233 25.0994 27.6372 26.044 27.0787 26.5467C26.7181 26.8712 26.424 27.298 25.9967 27.5116C25.5948 27.7126 25.8797 27.0015 25.9328 26.6035",
    stroke: "#2F7578",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabasesSkillSign);
export default __webpack_public_path__ + "static/media/databases_skill_sign.6cd2041c59a5245d1710edba3378383d.svg";
export { ForwardRef as ReactComponent };